export function horario() {
  /*
  Fuera de horario (true)
  Si la hora actual está fuera del rango de 8:00 a 21:50 de lunes a viernes.
  Si la fecha actual es el 1 de abril (Mes 4) o el 8 de noviembre o el 6 de noviembre o el 25 de diciembre o el 1 de enero o el 6 de enero o el 15 de agosto o el 1 de noviembre o el 5 de enero después de las 17:00.
  Si el día actual es sábado o domingo (día 6 o día 0).
  */
  const d = new Date()
  const diaActual = d.getDay()
  const horaActual = d.getHours()
  const MesActual = d.getMonth()
  const diaMes = d.getDate()
  const minutaActual = d.getMinutes()

  //Comprobar si es sabado - retorna false para iniciar el ringpool
  const esSabado = diaActual == 6 && horaActual >= 9 && horaActual <= 13;
  if (esSabado) return false;

  if (
    (
      (horaActual > 8 && (horaActual < 21 || (horaActual === 21 && minutaActual < 51)) && diaActual > 0 && diaActual < 6) === false) ||
    ((MesActual == 4 && diaMes == 1) === true) ||
    ((MesActual == 11 && diaMes == 8) === true) ||
    ((MesActual == 11 && diaMes == 6) === true) ||
    ((MesActual == 11 && diaMes == 25) === true) ||
    ((MesActual == 0 && diaMes == 1) === true) ||
    ((MesActual == 0 && diaMes == 6) === true) ||
    ((MesActual == 7 && diaMes == 15) === true) ||
    ((MesActual === 10 && diaMes === 1) === true) ||
    ((MesActual == 0 && diaMes == 5 && horaActual > 17) === true) ||
    ((MesActual == 12 && diaMes == 29) === true) ||
    ((MesActual == 12 && diaMes == 30) === true) ||
    (diaActual == 6) ||
    (diaActual == 0)
  ) {
    return true
  } else {
    return false
  }
}
